import React from 'react';
import { ChartBarIcon } from '@heroicons/react/24/outline';

const EmptyState = ({ searchQuery, filterCategory }) => (
  <div className="text-center py-12">
    <ChartBarIcon className="mx-auto h-12 w-12 text-gray-400" />
    <h3 className="mt-2 text-sm font-medium text-gray-900">
      No submissions found
    </h3>
    <p className="mt-1 text-sm text-gray-500">
      {searchQuery
        ? `No submissions found ${filterCategory ? `in ${filterCategory}` : ''} matching "${searchQuery}".`
        : `No submissions have been made ${filterCategory ? `for ${filterCategory}` : ''} yet.`}
    </p>
  </div>
);

export default EmptyState;
